import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGlobalStore = defineStore('global-store', () => {
    const is_sidebar_opened = ref(true)

    const toggleSidebar = () => {
        is_sidebar_opened.value = !is_sidebar_opened.value
    }

    const closeSidebar = () => {
        is_sidebar_opened.value = false
    }

    return {
        toggleSidebar,
        closeSidebar,
        is_sidebar_opened,
    }
})
